module.exports = __webpack_public_path__ + "img/coverIcon.699055ee.svg";